export default __webpack_public_path__ + "static/media/loader.ac5d5761.svg";